import React from 'react';
import { motion } from 'framer-motion';
import { personalInfo } from '../data/personalData';

export const CTA: React.FC = () => {
  return (
    <section id="contact" className="py-24 px-6 bg-background bg-dotgrid">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl mx-auto text-center"
      >
        <p className="font-mono text-sm text-accent mb-3">$ status</p>
        <h2 className="text-3xl sm:text-4xl font-bold text-text mb-4">
          Open to Data Analyst roles.
        </h2>
        <p className="text-muted mb-8">
          If you're hiring, or just want to talk about a dataset, my inbox is open.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <a
            href={`mailto:${personalInfo.email}`}
            className="px-6 py-3 bg-accent text-background font-mono text-sm font-semibold rounded hover:bg-accent/90 transition-colors"
          >
            email_me()
          </a>
          <a
            href="/contact"
            className="px-6 py-3 border border-border text-text font-mono text-sm rounded hover:border-accent hover:text-accent transition-colors"
          >
            contact_page()
          </a>
        </div>
      </motion.div>
    </section>
  );
};
